/**
 * Bio component that queries for data
 * with Gatsby's useStaticQuery component
 *
 * See: https://www.gatsbyjs.org/docs/use-static-query/
 */

import React from 'react';
import { useStaticQuery, graphql } from 'gatsby';
import Image from 'gatsby-image';

import { rhythm } from '../utils/typography';

const Bio = () => {
	const data = useStaticQuery(graphql`
		query BioQuery {
			avatar: file(absolutePath: { regex: "/profile-pic.jpg/" }) {
				childImageSharp {
					fixed(width: 50, height: 60) {
						...GatsbyImageSharpFixed
					}
				}
			}
			site {
				siteMetadata {
					author
					social {
						twitter
					}
				}
			}
		}
	`);

	const { author, social } = data.site.siteMetadata;
	return (
		<div
			style={{
				display: `flex`,
				marginBottom: rhythm(2.5)
			}}
		>
			<Image
				fixed={data.avatar.childImageSharp.fixed}
				alt={author}
				style={{
					marginRight: rhythm(1 / 2),
					marginBottom: 0,
					minWidth: 50,
					borderRadius: `60%`
				}}
				imgStyle={{
					borderRadius: `50%`
				}}
			/>
			<p>
				Written by <strong>{author}</strong>
				<br />
				Follow me on twitter <a href={`https://twitter.com/amansharma214/`}>Click here</a>
				<br />
				Follow me on linkedIn <a href={`https://www.linkedin.com/in/aman-sharma-b21b68196/`}>Click here</a>
			</p>
		</div >
	);
};

export default Bio;
